module.exports = __webpack_public_path__ + "img/newyorkpost.b21024a7.png";